export const RAPITOR_METRICS = {
  COUPON_ORDER_LIST_PV: 'coupon_order_list_pv',
  COUPON_ORDER_DETAIL_PV: 'coupon_order_detail_pv',
  COUPON_ORDER_REFUND_BUTTON: 'coupon_order_refund_button',
  COUPON_ORDER_REFUND_API: 'coupon_order_refund_api',
} as const
